'use client'
import * as React from 'react'
import { tw } from 'utils/classnames'

import { CheckIcon } from '@web/components/icons/check'

export function Button({
  textToCopy,
  icon,
  text,
  copiedLabel,
  showCheckWhenCopied = false,
  className,
  onClick,
}: {
  textToCopy: string
  icon: React.ReactNode
  text: string
  copiedLabel: string
  showCheckWhenCopied?: boolean
  className?: string
  onClick?: () => void
}) {
  const [isCopied, setIsCopied] = React.useState(false)
  React.useEffect(() => {
    if (isCopied) {
      const timeout = setTimeout(() => {
        setIsCopied(false)
      }, 2000)
      return () => clearTimeout(timeout)
    }
  }, [isCopied])
  const showCheckIcon = isCopied && showCheckWhenCopied

  return (
    <button
      className={tw(
        'bg-cf-white rounded-2 hover:shadow-cf-elevation-light-1 grow-0 border-l border-[#DFDDE5]',
        'flex items-center justify-center gap-2 p-2 px-4',
        className,
      )}
      onClick={e => {
        e.preventDefault()
        navigator.clipboard.writeText(textToCopy)
        setIsCopied(true)
        onClick?.()
      }}
    >
      {!showCheckIcon ? icon : <CheckIcon className="text-clover-500 w-4" />}
      <span>{!showCheckIcon ? text : copiedLabel}</span>
    </button>
  )
}

export function LinkButton({
  href,
  icon,
  text,
  className,
}: {
  href: string
  icon: React.ReactNode
  text: string
  className?: string
}) {
  return (
    <a
      target="_blank"
      href={href}
      className={tw(
        'bg-cf-white rounded-2 hover:shadow-cf-elevation-light-1 grow-0 border-l border-[#DFDDE5]',
        'flex items-center justify-center gap-2 p-2 px-4',
        className,
      )}
      rel="noreferrer"
    >
      {icon}
      <span>{text}</span>
    </a>
  )
}
